import React from "react";
import Follow from "../btn/Follow";

const ProductIndividual = ({ data }) => {
  const { user, product, full_address } = data;
  const { profile_image, user_name } = user;
  const states = ["lagos", "kwara", "osun"];
  return (
    <div className="mt-5 ">
      <div className="flex w-full flex-row justify-between items-center">
        <div className="flex w-full gap-5 items-center">
          <img
            alt="user profile"
            src={profile_image}
            className="w-16 h-16 rounded-full"
          />
          <div className="">
            <p className="font-bold text-md md:text-xl">{`${user_name}'s Thrift Shop`}</p>
            {states.map(
              (state) =>
                full_address.includes(state) && (
                  <div
                    key={state}
                    className="font-normal text-base text-label capitalize"
                  >{`${state}, Nigeria`}</div>
                )
            )}
          </div>
        </div>
        <div className="">
          <Follow />
        </div>
      </div>

      <div className="overflow-x-scroll scrollbar-thin  md:overflow-x-auto">
        <div className="flex w-[480px] md:w-auto gap-4 mt-5">
          {product.slice(0, 3).map(({ product_image: { front_view } }) => (
            <div key={front_view}>
              <img
                src={front_view}
                alt="product"
                className="w-[150px] h-[150px] md:w-[150px] md:h-[150px]"
              />
            </div>
          ))}
        </div>
      </div>
      <div className="mt-5 font-normal text-lg text-logoRed">Visit Store</div>
    </div>
  );
};

export default ProductIndividual;
